import React, { ReactNode, useState } from "react";
import { FaCaretDown, FaEye, FaTrash } from "react-icons/fa";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { RelatorioNotasDaTurmaPaginaResponse } from "../../../api/relatorios";
import "./CelulaNota.css";

const degrade = [
  { step: 100, color: [0x2c, 0xc4, 0xff] },
  { step: 90, color: [0x2c, 0xc4, 0xff] },
  { step: 89, color: [0x27, 0xff, 0x18] },
  { step: 80, color: [0x27, 0xff, 0x18] },
  { step: 79, color: [0xf1, 0xff, 0x00] },
  { step: 70, color: [0xf1, 0xff, 0x00] },
  { step: 69, color: [0xff, 0xae, 0x27] },
  { step: 60, color: [0xff, 0xae, 0x27] },
  { step: 59, color: [0xff, 0x0a, 0x00] },
  { step: 0, color: [0xff, 0x0a, 0x00] },
];

export function CelulaNota(props: {
  onView?: () => void;
  onDelete?: () => void;
  nota?: number;
  paginas?: RelatorioNotasDaTurmaPaginaResponse[];
  className?: string;
  children?: ReactNode;
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mouseOver, setMouseOver] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const n = props.nota;
  const fundo = notaColor(n);
  const hasClick = !!(props.onView || props.onDelete);

  return (
    <td
      className={
        "text-center align-middle relatorioCelulaNotaDoAluno " +
        (props.className ?? "")
      }
      onClick={hasClick ? () => toggleDropdown() : undefined}
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => {
        setMouseOver(false);
        setDropdownOpen(false);
      }}
      role={hasClick ? "button" : ""}
    >
      {hasClick && mouseOver && (
        <Dropdown isOpen={dropdownOpen} className="relatorioBoxNotaDropdown">
          <DropdownToggle data-toggle="dropdown" tag="span">
            <FaCaretDown />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              className="relatorioResumoPaginasItem"
              disabled
              toggle={false}
            >
              {renderResumoPaginas(props.paginas)}
            </DropdownItem>
            {props.onView && (
              <DropdownItem onClick={props.onView}>
                <FaEye /> Ver correção
              </DropdownItem>
            )}
            {props.onDelete && (
              <DropdownItem onClick={props.onDelete}>
                <FaTrash /> Excluir
              </DropdownItem>
            )}
          </DropdownMenu>
        </Dropdown>
      )}
      <div
        className="relatorioBoxNotaDoAluno"
        style={{ backgroundColor: fundo }}
      >
        {formatarNota(n)}
      </div>
      {props.children}
    </td>
  );
}

function notaRgb(n?: number | null): [number, number, number] {
  let rgb: [number, number, number] = [255, 255, 255];
  if (n !== undefined && n !== null) {
    const step = Math.round(n * 10);
    let begin = degrade[0];
    let end = begin;
    for (let i = 1; i < degrade.length; i++) {
      if (step >= degrade[i].step) {
        end = degrade[i];
        break;
      } else {
        begin = degrade[i];
      }
    }
    const t = (begin.step - step) / (begin.step - end.step);
    rgb = [
      Math.round(begin.color[0] + t * (end.color[0] - begin.color[0])),
      Math.round(begin.color[1] + t * (end.color[1] - begin.color[1])),
      Math.round(begin.color[2] + t * (end.color[2] - begin.color[2])),
    ];
  }
  return rgb;
}

function notaColor(n?: number | null): string {
  const rgb = notaRgb(n);
  const fundo = `rgb(${rgb[0]},${rgb[1]},${rgb[2]})`;
  return fundo;
}

function renderResumoPaginas(paginas?: RelatorioNotasDaTurmaPaginaResponse[]) {
  if (!paginas?.length) {
    return "Páginas: --";
  }

  return (
    <dl className="relatorioResumoPaginaNota">
      {paginas.map((p) => (
        <React.Fragment key={p.pageIndex}>
          <dt>{String.fromCharCode(65 + p.pageIndex)}</dt>
          <dd style={{ backgroundColor: notaColor(p.nota) }}>
            {formatarNota(p.nota)}
          </dd>
        </React.Fragment>
      ))}
    </dl>
  );
}

export function formatarNota(n?: number | null): string {
  if (n === undefined || n === null) return "--";
  return (Math.round(10 * n) / 10).toFixed(1).replace(".", ",");
}
